
import { Union, Record } from "./fable_modules/fable-library-js.5.0.0/Types.js";
import { SessionState_$reflection } from "../../Server/Shared.fs.js";
import { union_type, string_type, option_type, record_type, bool_type } from "./fable_modules/fable-library-js.5.0.0/Reflection.js";
import { FSharpResult$2 } from "./fable_modules/fable-library-js.5.0.0/Result.js";
import { singleton } from "./fable_modules/fable-library-js.5.0.0/AsyncBuilder.js";
import { getStateCount, getSessionState } from "./Remoting.fs.js";
import { Cmd_OfAsyncWith_perform } from "./fable_modules/Fable.Elmish.5.0.2/./cmd.fs.js";
import { AsyncHelpers_start } from "./fable_modules/Fable.Elmish.5.0.2/./prelude.fs.js";
import { max } from "./fable_modules/fable-library-js.5.0.0/Double.js";
import { Cmd_none } from "./fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { singleton as singleton_1 } from "./fable_modules/fable-library-js.5.0.0/List.js";

/**
 * State of the user interface.
 */
export class InnerState extends Record {
    constructor(SessionState, Busy) {
        super();
        this.SessionState = SessionState;
        this.Busy = Busy;
    }
}

export function InnerState_$reflection() {
    return record_type("NetHack.Web.InnerState", [], InnerState, () => [["SessionState", SessionState_$reflection()], ["Busy", bool_type]]);
}

/**
 * Creates an inner state.
 */
export function InnerStateModule_create(sessionState, busy) {
    return new InnerState(sessionState, busy);
}

/**
 * Elmish message.
 */
export class Message extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SetState", "GetNextState", "GetPreviousState", "Rewind", "FastForward"];
    }
}

export function Message_$reflection() {
    return union_type("NetHack.Web.Message", [], Message, () => [[["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [option_type(InnerState_$reflection()), string_type], FSharpResult$2, () => [[["ResultValue", option_type(InnerState_$reflection())]], [["ErrorValue", string_type]]])]], [], [], [], []]);
}

function MessageModule_getState(stateIdx) {
    return singleton.Delay(() => singleton.Bind(getSessionState(stateIdx), (_arg) => ((_arg.tag === 1) ? singleton.Return(new FSharpResult$2(1, [_arg.fields[0]])) : singleton.Return(new FSharpResult$2(0, [InnerStateModule_create(_arg.fields[0], false)])))));
}

const MessageModule_getCurrentStateCmd = Cmd_OfAsyncWith_perform((x) => {
    AsyncHelpers_start(x);
}, () => singleton.Delay(() => singleton.Bind(getStateCount(), (_arg) => {
    if (_arg.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, [_arg.fields[0]]));
    }
    else {
        const idx = max(_arg.fields[0] - 1, 0) | 0;
        return singleton.ReturnFrom(MessageModule_getState(idx));
    }
})), undefined, (Item) => (new Message(0, [Item])));

/**
 * Gets initial state and triggers request for most recent
 * server state.
 */
export function MessageModule_init() {
    return [new FSharpResult$2(0, [undefined]), MessageModule_getCurrentStateCmd];
}

function MessageModule_getStateCmd(stateIdx) {
    return Cmd_OfAsyncWith_perform((x) => {
        AsyncHelpers_start(x);
    }, MessageModule_getState, stateIdx, (Item) => (new Message(0, [Item])));
}

function MessageModule_handleGetState(f, state) {
    let matchResult, inner_1, state_1;
    if (state.tag === 0) {
        if (state.fields[0] != null) {
            if (!state.fields[0].Busy) {
                matchResult = 0;
                inner_1 = state.fields[0];
            }
            else {
                matchResult = 1;
                state_1 = state;
            }
        }
        else {
            matchResult = 1;
            state_1 = state;
        }
    }
    else {
        matchResult = 1;
        state_1 = state;
    }
    switch (matchResult) {
        case 0:
            return [new FSharpResult$2(0, [new InnerState(inner_1.SessionState, true)]), MessageModule_getStateCmd(f(inner_1.SessionState.Index))];
        default:
            return [state_1, Cmd_none()];
    }
}

function MessageModule_handleFastForward(state) {
    let matchResult, inner_1, state_1;
    if (state.tag === 0) {
        if (state.fields[0] != null) {
            if (!state.fields[0].Busy) {
                matchResult = 0;
                inner_1 = state.fields[0];
            }
            else {
                matchResult = 1;
                state_1 = state;
            }
        }
        else {
            matchResult = 1;
            state_1 = state;
        }
    }
    else {
        matchResult = 1;
        state_1 = state;
    }
    switch (matchResult) {
        case 0:
            return [new FSharpResult$2(0, [new InnerState(inner_1.SessionState, true)]), MessageModule_getCurrentStateCmd];
        default:
            return [state_1, Cmd_none()];
    }
}

/**
 * Updates the user interface based on the given message.
 */
export function MessageModule_update(msg, state) {
    switch (msg.tag) {
        case 1:
            return MessageModule_handleGetState((idx) => ((idx + 1) | 0), state);
        case 2:
            return MessageModule_handleGetState((idx_1) => ((idx_1 - 1) | 0), state);
        case 3:
            return MessageModule_handleGetState((_arg) => 0, state);
        case 4:
            return MessageModule_handleFastForward(state);
        default:
            return [msg.fields[0], Cmd_none()];
    }
}

/**
 * Subscribes to the Enter key regardless of where the focus is.
 */
export function MessageModule_subscribe(_arg) {
    return singleton_1([singleton_1("keydown"), (dispatch) => {
        const onKeyDown = (evt) => {
            if (evt.key === "Enter") {
                dispatch(new Message(1, []));
            }
        };
        window.addEventListener("keydown", onKeyDown);
        return {
            Dispose() {
                window.removeEventListener("keydown", onKeyDown);
            },
        };
    }]);
}

